export default {
    //Dashboard
    headerTopIcon: require('./logo-voc.png'),
    zigzagGreen: require('./zigzag-green.png'),
};